/**
 * Which plain-language answer a failed sign-in-link request deserves.
 *
 * Rate limiting and a slow mail hook are both "wait a moment", not "your
 * address is wrong", and the raw provider text says neither.
 */
export function signInFailureKey(failure: {
  status?: number;
  code?: string;
  message?: string;
}): string {
  const code = failure.code ?? "";
  const message = failure.message ?? "";
  if (
    failure.status === 429 ||
    code.includes("rate_limit") ||
    /rate limit/i.test(message)
  ) {
    return "account.tooManyLinks";
  }
  if (code.includes("hook") || /hook|timeout/i.test(message)) {
    return "account.linkDelayed";
  }
  return "account.linkFailed";
}
